module.exports = __webpack_public_path__ + "img/logo.2522b422.png";